import * as L from "leaflet";
import { IBoundLayer, IBoundLayerOptions } from "../BoundLayer";
import { ISiteState } from "../../redux/modules/site/reducer";
import { IStoreState } from "../../redux/rootReducer";

export default class SiteBoundariesLayer extends L.LayerGroup
  implements IBoundLayer {
  public options: IBoundLayerOptions;
  public featuresLayer: L.Layer;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
  }

  public onAdd(map: L.Map) {
    this.map = map;
    L.LayerGroup.prototype.onAdd.call(this, map);
    this.drawSiteBoundary();
    return this;
  }

  public onRemove(map: L.Map) {
    L.LayerGroup.prototype.onRemove.call(this, map);
    this.map = null;
    return this;
  }

  public update() {
    return;
  }

  private drawSiteBoundary() {
    const state: IStoreState = this.options.getState();
    const siteState: ISiteState = state.site;

    const geojsonBoundaries = siteState.data.boundary;
    const siteBoundariesLayer = L.geoJSON(geojsonBoundaries, {
      style() {
        return {
          color: "#000",
          fillOpacity: 0,
        };
      },
    });
    this.addLayer(siteBoundariesLayer);
  }
}
